<template>
    <div class="footer">
        <footer>
            <b-container fluid class="px-4">
                <b-row align-v="stretch" align-h="between" class="footer-layout">
                    <b-col cols="12" lg="7" class="footer-primary">
                        <div class="footer_info" v-html="info"></div>
                        <div class="social_row">
                            <div class="social-media" v-html="social" style="display: flex;"></div>
                        </div>
                    </b-col>

                    <b-col cols="12" lg="5" class="footer-secondary px-lg-4">
                        <div class="footer-right-panel">
                            <div class="footer_quickMap">
                                <b-row align-v="stretch" class="text-nowrap justify-content-between footer-links">
                                    <b-col cols="6" sm="auto" class="h-100 line">
                                        <h6>關於</h6>
                                        <b-nav vertical>
                                            <b-nav-item @click="_go1('./#/about', 1)">關於我們</b-nav-item>
                                            <b-nav-item>
                                                <b-button
                                                    v-b-modal.modal-privacy
                                                    style="background: unset; color: rgba(255, 255, 255, 0.65); font-size: 0.9rem;"
                                                    class="p-0 border-0"
                                                >
                                                    個資保護政策
                                                </b-button>
                                            </b-nav-item>
                                            <b-nav-item @click="_go1('https://www.fcu.edu.tw/map/', 1)">校園地圖</b-nav-item>
                                            <b-nav-item @click="_go1('https://www.fcu.edu.tw/traffic/', 1)">交通建議</b-nav-item>
                                        </b-nav>
                                    </b-col>
                                    <b-col cols="6" sm="auto" class="line">
                                        <h6>幫助</h6>
                                        <b-nav vertical>
                                            <b-nav-item to="/news">最新消息</b-nav-item>
                                            <b-nav-item to="/qanda">常見問題</b-nav-item>
                                        </b-nav>
                                    </b-col>
                                </b-row>
                            </div>

                            <section v-if="visitorStats.length" class="footer-visitor" aria-label="網站訪客統計">
                                <div class="visitor-card-header">
                                    <!-- <h6 class="mb-0">網站訪客統計</h6> -->
                                </div>
                                <div class="visitor-stat-list">
                                    <div class="visitor-stat-item row w-100" v-for="item in visitorStats" :key="item.key">
                                        <span class="visitor-stat-label text-nowrap col-2 p-2">{{ item.label }}</span>
                                        <strong class="visitor-stat-value col-9 text-right p-2">{{ item.value }} <span class="visitor-stat-unit">人</span></strong>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="d-none"></b-row>
            </b-container>
        </footer>
        <div class="footer-nav">
            <b-container fluid class="px-0">
                Copyright 逢甲大學 Feng Chia University
            </b-container>
        </div>
    </div>
</template>

<script>
import { apiGetInformation, apiGetInfo } from '@/api/API.js';

export default {
    name: 'page-footer',
    components: {},
    data() {
        return {
            info: '',
            social: '',
            siteMetric: null,
        };
    },
    computed: {
        visitorStats() {
            const metrics = this.siteMetric && typeof this.siteMetric === 'object'
                ? this.siteMetric
                : {};

            return [
                { key: 'yesterdayViews', expectedName: 'yesterday_views', label: '昨日訪客' },
                { key: 'todayViews', expectedName: 'today_views', label: '今日訪客' },
                { key: 'totalViews', expectedName: 'total_views', label: '本站總訪' },
            ]
                .map(({ key, expectedName, label }) => {
                    const item = metrics[key];

                    if (!item || item.name !== expectedName || item.enable !== true) {
                        return null;
                    }

                    return {
                        key,
                        label,
                        value: item.content ?? '',
                    };
                })
                .filter(Boolean);
        },
    },
    created() {
        apiGetInformation('footer_info')
            .then((res) => {
                this.info = res.data.Content;
            })
            .catch((err) => {
                console.log(err);
            });

        apiGetInformation('footer_social')
            .then((res) => {
                this.social = res.data.Content;
            })
            .catch((err) => {
                console.log(err);
            });

        apiGetInfo()
            .then((res) => {
                this.siteMetric = res.data?.Content ?? res.data ?? null;
            })
            .catch((err) => {
                console.log(err);
            });
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss">
.footer {
    .footer-layout {
        row-gap: 2rem;
    }

    .footer-primary {
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
    }

    .footer-secondary {
        display: flex;
        align-items: flex-end;
    }

    .footer-right-panel {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: stretch;
        width: 100%;
        max-width: 270px;
        margin-left: auto;
        gap: 0.9rem;
    }

    .footer-links {
        margin-bottom: 0;
    }

    .footer-visitor-card {
        width: 100%;
        max-width: none;
        padding: 0.75rem 0.95rem;
        border-radius: 14px;
        background: linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.03));
        border: 1px solid rgba(255, 255, 255, 0.12);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.16);
        backdrop-filter: blur(6px);
    }

    .visitor-card-header {
        margin-bottom: 0.55rem;

        h6 {
            color: #fff;
            font-size: 0.92rem;
            font-weight: 700;
        }
    }

    .visitor-eyebrow {
        display: inline-block;
        margin-bottom: 0.15rem;
        color: rgba(255, 255, 255, 0.48);
        font-size: 0.68rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }

    .visitor-stat-item {
        align-items: baseline;
        column-gap: 0.45rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.12);

        &:last-child {
            padding-bottom: 0;
            border-bottom: 0;
        }
    }

    .visitor-stat-label {
        color: rgba(255, 255, 255, 0.72);
        font-size: 0.82rem;
    }

    .visitor-stat-value {
        color: #fff;
        font-size: 1.05rem;
        line-height: 1;
        font-variant-numeric: tabular-nums;
    }

    .visitor-stat-unit {
        color: rgba(255, 255, 255, 0.68);
        font-size: 0.78rem;
    }
}

@media (max-width: 991.98px) {
    .footer {
        .footer-right-panel {
            align-items: stretch;
            max-width: none;
        }

        .footer-visitor-card {
            max-width: none;
        }
    }
}

@media (max-width: 575.98px) {
    .footer {
        .footer-visitor-card {
            padding: 0.95rem 1rem;
            border-radius: 14px;
        }

        .visitor-stat-item {
            grid-template-columns: 1fr auto;
            grid-template-areas:
                'label unit'
                'value value';
            row-gap: 0.2rem;
        }

        .visitor-stat-label {
            grid-area: label;
        }

        .visitor-stat-value {
            grid-area: value;
            font-size: 1.6rem;
        }

        .visitor-stat-unit {
            grid-area: unit;
            justify-self: end;
        }
    }
}
</style>
